<template>
    <label :for="(idPrefix ?idPrefix +'_':'')+'input_' + id + '_'+name" class="flex items-center text-left relative" @mouseover="hover = true" @mouseleave="hover = false" @click="$emit('input', radioValue)">
        <div class="absolute bg-gray-500 h-8 w-8 -top-4.5 -left-2.5 rounded-full transform" :class="[isChecked ? 'scale-100 opacity-0 transition-all ease-in-out duration-300' : 'scale-0 opacity-50']"></div>
        <div class="border rounded-full relative transition-all  ease-in-out duration-500 h-4 w-4 block" :class="[{ checked: isChecked, 'opacity-25 cursor-not-allowed':disabled} ,  inputClass ? inputClass : '' , hover && !focused && !hasErrors ? 'border-primary-dark' : '', hover && focused && !hasErrors || focused && !hasErrors ? 'border-primary-darker' : '', !hover && !hasErrors ? 'border-gray-300' : '', hasErrors ? 'border-secondary-light' : '']">
            <div class="pointer-events-none bg-primary-default transition-all transform ease-in-out duration-300 rounded-full absolute top-0 left-0 h-full w-full" :class="[isChecked ? 'scale-75 opacity-100' : 'scale-0 opacity-0']"></div>
            <input :id="(idPrefix ?idPrefix +'_':'')+'input_' + id + '_'+name" type="radio" class="absolute w-full h-full top-0 left-0 opacity-0"
                   :value="radioValue"
                   :checked="isChecked"
                   @keyup.enter="$emit('click')"
                   @blur="$emit('blur')"
                   @change="$emit('update', radioValue)"
                   :disabled="disabled"
                   :name="name"
            >
        </div>
        <span class="text-sm pl-2" :class="[ this.hasErrors && !hideErrors ? 'text-secondary-default' : (labelClass ? labelClass : 'text-text-default')]">
             <slot/>
        </span>
    </label>
</template>
<script>

    export default {
        data() {
            return {
                focused: false,
                hover: false
            }
        },
        props: {
            idPrefix: {
                type: String,
                required: false
            },
            id: {
                type: String,
                required: true
            },
            name: {
                type: String,
                required: true
            },
            labelClass: {
                type: String,
                required: false
            },
            radioValue: {
                type: String,
                required: true
            },
            validations: {
                type: Array,
                default: () => []
            },
            disabled: {
                type: Boolean,
                required: false,
                default: false
            },
            hideErrors: {
                type: Boolean,
                required: false,
                default: true
            },
            inputClass: {
                type: String,
                required: false,
            },
            focus: {
                type: Boolean,
                required: false,
                default: false
            },
        },
        computed: {
            hasErrors() {

                var hasErrors = false;
                this.validations.forEach(validation => {

                    if (validation.condition) {
                        hasErrors = true;
                        return;
                    }
                })

                return hasErrors;
            },
            isChecked() {
                return this.$attrs.modelValue == this.radioValue
            }
        },
        methods: {
            onFocus() {
                this.focused = true;
            },
            onBlur() {
                this.focused = false;
            },
            setFocus(fieldName) {
                if (this.name === fieldName) {
                    this.$refs[this.name].focus()
                }
            }
        }
    }
</script>

